import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { ExplorerIcon } from '@plato/ui-legacy/assets/icons/explorer-icon';
import { Page } from '@plato/ui-legacy/components/ui/page';
import { PageHeader } from '@plato/ui-legacy/components/ui/page-header';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExplorerTopLevelEntity } from '../../../server/utils/explorer-utils.ts';
import { ExplorerSavedFilterViews } from '../components/explorer-saved-filter-views.tsx';
import { ExplorerViewActions } from '../components/explorer-view-actions.tsx';
import { ExplorerView } from '../components/explorer-view.tsx';
import { ExplorerViewProvider, useExplorerQueryParams } from '../hooks/use-explorer-query-params.ts';

export function ExplorerViewPage() {
    const { t } = useTranslation();
    const { enableSaveSalesReport } = useAppConfig();
    const [key] = useState(() => Date.now());
    const [state, setState] = useExplorerQueryParams({ tab: ExplorerTopLevelEntity.CUSTOMER });

    return (
        <Page>
            <ExplorerViewProvider value={{ state, setState, defaultFilters: {} }}>
                <PageHeader
                    icon={ExplorerIcon}
                    subTitle={t('page_sub_title__explorer')}
                    actions={<ExplorerViewActions />}
                    title={t('page_title__explorer')}
                    className="[&_h1]:whitespace-nowrap"
                >
                    {enableSaveSalesReport && <ExplorerSavedFilterViews />}
                </PageHeader>
                <ExplorerView pageSource="standalone" className="overflow-y-hidden grow-0" key={key} />
            </ExplorerViewProvider>
        </Page>
    );
}
